<div id="finalpaymentJuncture" class="container">
  <div class="row">
    <div class="col-12 p-0">
      <div class="component-header __indicator">
        <h3 class="label m-0">{{ 'junctures.finalPayment.header' | translate }}</h3>
      </div>
    </div>

    <div class="col-12 pt-4 text-center">
      <fa-icon class="faCreditCard" [icon]="faCreditCard"></fa-icon>
      <p class="mb-0">{{ 'junctures.finalPayment.amount' | translate }}</p>
      <h1 class="payment-amount">{{this.formatCurrency(this._insuranceFee)}} {{ 'common.huf' | translate }}</h1>
      <button type="button" class="btn pay-button mt-3" (click)="startOnlinePayment()">{{ 'junctures.finalPayment.payment' | translate }}</button>
      @if (DataService.selectedLanguage === 'en') {
        <div class="payment-info-en">
          <span class="payment-text">
            {{ 'junctures.finalPayment.info' | translate }}
          </span>
          <br>
            <img src="assets/payment/Onlinepayment_en.png" class="payment-img">
          </div>
        }
      </div>
    </div>
  </div>
